import { render, staticRenderFns } from "./ViewSignature.vue?vue&type=template&id=1a4e3d10&scoped=true"
import script from "./ViewSignature.vue?vue&type=script&lang=js"
export * from "./ViewSignature.vue?vue&type=script&lang=js"
import style0 from "./ViewSignature.vue?vue&type=style&index=0&id=1a4e3d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e3d10",
  null
  
)

export default component.exports